import { FaEnvelope, FaFacebook, FaGlobe, FaInstagram, FaYoutube, FaTiktok, FaLinkedin } from 'react-icons/fa';

const links = [
   {
      name: "Mail",
      link: "mailto:falcon@joancompany.es",
      icon: FaEnvelope,
   },
   {
      name: "Web Page",
      link: "https://www.joancompany.es/",
      icon: FaGlobe,
   },
   {
      name: "Instagram",
      link: "https://www.instagram.com/falcon_fpv/",
      icon: FaInstagram,
   },
   {
      name: "LinkedIn",
      link: "https://www.linkedin.com/in/joan-company-pastor-b5aa6b27b/",
      icon: FaLinkedin,
   },
   {
      name: "Facebook",
      link: "https://www.facebook.com/profile.php?id=100023819556799",
      icon: FaFacebook,
   },
   {
      name: "YouTube",
      link: "https://www.youtube.com/@JoanCompany-FalconFPV",
      icon: FaYoutube,
   },
   {
      name: "TikTok",
      link: "https://www.tiktok.com/@joan.falcon_fpv",
      icon: FaTiktok,
   },
];

export default links;